import { CUSTOMER_STEP } from "../data/leadFormSteps";
import DynamicAccordionBlock from "../components/DynamicAccordionBlock";
import DynamicFieldGrid from "../components/DynamicFieldGrid";

const [personalBlock, addressBlock, employmentBlock, coFlagBlock, coborrowerParentBlock] = CUSTOMER_STEP.blocks;

export default function CustomerDetailsStep({
  v,
  onFieldChange,
  coborrowers,
  onCoborrowerFieldChange,
  openCust,
  onToggleCust,
  openCb,
  onToggleCb,
  onCopyBorrower,
  errors,
  coErrors,
  configOptions,
  readOnly,
}) {
  return (
    <div>
      <DynamicAccordionBlock
        title={personalBlock.title}
        open={openCust === personalBlock.key}
        onToggle={() => onToggleCust(personalBlock.key)}
        fields={personalBlock.fields}
        values={v}
        onChange={onFieldChange}
        errors={errors}
        configOptions={configOptions}
        readOnly={readOnly}
        showRequired
      />
      <DynamicAccordionBlock
        title={addressBlock.title}
        open={openCust === addressBlock.key}
        onToggle={() => onToggleCust(addressBlock.key)}
        fields={addressBlock.fields}
        values={v}
        onChange={onFieldChange}
        errors={errors}
        configOptions={configOptions}
        readOnly={readOnly}
        showRequired
      />
      <DynamicAccordionBlock
        title={employmentBlock.title}
        open={openCust === employmentBlock.key}
        onToggle={() => onToggleCust(employmentBlock.key)}
        fields={employmentBlock.fields}
        values={v}
        onChange={onFieldChange}
        errors={errors}
        configOptions={configOptions}
        readOnly={readOnly}
        showRequired
      />

      <div style={{ paddingTop: 18 }}>
        <DynamicFieldGrid
          fields={coFlagBlock.fields}
          values={v}
          onChange={onFieldChange}
          errors={errors}
          configOptions={configOptions}
          readOnly={readOnly}
          showRequired
        />

        {v.has_coborrower === "yes" &&
          coborrowers.map((coborrower, index) => (
            <div className="cb-section" key={index}>
              <div className="cb-section__head">
                <h3>
                  {coborrowerParentBlock.title} {coborrowers.length > 1 ? index + 1 : ""}
                </h3>
                <button type="button" className="copy-borrower-btn" onClick={() => onCopyBorrower(index)}>
                  Copy Borrower Address
                </button>
              </div>
              {coborrowerParentBlock.blocks.map((b) => (
                <DynamicAccordionBlock
                  key={b.key}
                  title={b.title}
                  open={openCb[index] === b.key}
                  onToggle={() => onToggleCb(index, b.key)}
                  fields={b.fields}
                  values={coborrower}
                  onChange={(fieldName, val) => onCoborrowerFieldChange(index, fieldName, val)}
                  errors={coErrors[index]}
                  configOptions={configOptions}
                  readOnly={readOnly}
                  showRequired
                />
              ))}
            </div>
          ))}
      </div>
    </div>
  );
}
